import styles from './pages.module.scss';
import WrappedSvg from '../../../../../assets/svg/wrapped/totPren.svg';

const TotPren = ({totalPren}) => {

    return (
        <div className={styles.card}>
            <img src={WrappedSvg} alt="Wrapped" className={styles.background_image} />
            <div className={styles.title_container}>
                <h1 className={styles.title} style={{color: '#ff4800'}}>Prenotazioni totali</h1>
                <h1 className={styles.value_pren}>{totalPren || 0}</h1>
            </div>
        </div>
    );
}

export default TotPren;
